import useGetPopularRentedProducts from './useGetPopularRentedProducts'

export default useGetPopularRentedProducts
